var errorToString = function(err, filter, space){
    if(!(err instanceof Object)) return;
    var plainObject = {};
    Object.getOwnPropertyNames(err).forEach(function(key) {
        plainObject[key] = err[key];
    });
    return JSON.stringify(plainObject, filter, space);
};
var capture = function(type, subType, data, file, line, col) {
        this.report.apply(this, arguments); //钩子
        var config = this.config;
        if(!config.logUrl) return;
        if(window.XMLHttpRequest && this.config.captureTypes.indexOf(type.toLowerCase()) != -1) {
            var xhr = new XMLHttpRequest();
            var log = {
                type: type,
                data: {
                    location:{
                        host: location.host,
                        origin: location.origin,
                        pathname: location.pathname,
                        search: location.search
                    },
                    type: subType,
                    file: file,
                    line: line,
                    col: col,
                    ua: navigator.userAgent,
                    message: JSON.parse(data)
                }
            };
            var params = config.params;
            if(params instanceof Object){
                for(var i in params){
                    log.data[i] = params[i];
                }
            }
            xhr.open('POST', config.logUrl);
            xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
            xhr.send(JSON.stringify(log));

        }
        return true;
};

var JsLogger = function(){
    this.config = {
        logUrl: null,
        params: {},
        captureTypes: ['warn', 'error', 'info'],
        consoleOutput: false
    };
    ['info', 'log', 'warn', 'error'].forEach(function(key){
	var _this = this;
        _this[key] = function(data, subType) {
            if(key == 'error' && subType === undefined){
                subType = 'js';
            }
            if (_this.config.consoleOutput) console[key].call(console, data);
            capture.call(_this, key, subType, errorToString(data));
        };
    }.bind(this));
    this.init = function(config){
        if(config instanceof Object) {
            for(var o in config) {
                this.config[o] = config[o];
            }
        }
        window.onerror = function(message, file, line, col, error){
            error.messageTxt = message;
            capture.call(this, 'error', 'js', errorToString(error), file, line, col);
        }.bind(this);
    };
};


JsLogger.prototype.report = function(){};//钩子函数
module.exports = new JsLogger();
